import { getDataSimple } from "../helpers/apiHelperV3";
import { urls } from "./urls";
const API_REGISTRATION_CURRENCIES = urls.cashier.API_REGISTRATION_CURRENCIES();

/**
 * fetch currencies available for public registration
 */
export const fetchRegistrationCurrencies = (): any => {
  const url = API_REGISTRATION_CURRENCIES;
  return getDataSimple(url);
};
